import { createAsyncThunk } from "@reduxjs/toolkit";

const API_BASE = process.env.REACT_APP_API_BASE;

/**
 * Fetch unseen celebration events
 */
export const fetchUnseenCelebrationEvents = createAsyncThunk(
  "celebration/fetchUnseen",
  async (_, { rejectWithValue }) => {
    try {
      const res = await fetch(
        `${API_BASE}/api/celebration-events/unseen`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "x-user-role": "partner",
          },
        }
      );

      const json = await res.json();
      if (!res.ok) {
        throw new Error(json?.message || "Fetch failed");
      }

      return json?.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

/**
 * Mark a single celebration event as seen
 */
export const markCelebrationSeen = createAsyncThunk(
  "celebration/markSeen",
  async (eventId, { rejectWithValue }) => {
    try {
      const res = await fetch(
        `${API_BASE}/api/celebration-events/${eventId}/seen`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "x-user-role": "partner",
          },
        }
      );

      if (!res.ok) {
        const json = await res.json();
        throw new Error(json?.message || "Mark seen failed");
      }

      return eventId;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

/**
 * Mark all celebration events as seen
 */
export const markAllCelebrationsSeen = createAsyncThunk(
  "celebration/markAllSeen",
  async (_, { rejectWithValue }) => {
    try {
      const res = await fetch(
        `${API_BASE}/api/celebration-events/mark-all-seen`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "x-user-role": "partner",
          },
        }
      );

      if (!res.ok) {
        const json = await res.json();
        throw new Error(json?.message || "Mark all seen failed");
      }

      return true;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);
